<script setup lang="ts">

import { TransactionWithdrawListActionTypes, useTransactionWithdrawListStore } from '@/modules/transaction/stores/transaction_withdraw.list.store.ts'
import DepositPanel from '@/modules/transaction/views/DepositPanel.vue'
import WithdrawPanel from '@/modules/transaction/views/WithdrawPanel.vue'
import DataTable from '@/onenetwork/components/datatable/DataTable.vue'
import FilterList from '@/onenetwork/components/filter/FilterList.vue'
import Modal from '@/onenetwork/components/modal/Modal.vue'
import _ from 'lodash'
import { computed, onMounted, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import WithdrawProcess from './WithdrawProcess.vue'
import DashboardLayout from '@/onenetwork/layouts/DashboardLayout.vue'

interface Props {
  account?: object | undefined
  defautAction?: string | undefined
}

const props = defineProps<Props>()

const displayDepositPanel = ref(false)
const displayWithdrawPanel = ref(false)
const displayWithdrawProcessPanel = ref(false)
const selectedWithdrawItem = ref<any>({})

const router = useRouter()

const transactionWithdrawListStore = useTransactionWithdrawListStore()

watch(() => props.defautAction, (newVal) => {
  transactionWithdrawListStore.resetFilter()
  if (newVal === 'deposit') {
    transactionWithdrawListStore.putFilter('type', 'deposit')
  } else if (newVal === 'withdraw') {
    transactionWithdrawListStore.putFilter('type', 'withdrawal')
  }
}, { immediate: true })


const TableConfig = computed(() => {
  return transactionWithdrawListStore.tableConfig
})
const filter = computed(() => {
  return transactionWithdrawListStore.filter
})
const loading = computed(() => {
  return transactionWithdrawListStore.action_type == TransactionWithdrawListActionTypes.FETCHING
})
const page = computed(() => {
  return transactionWithdrawListStore.page
})
const pageSize = computed(() => {
  return transactionWithdrawListStore.pageSize
})
const dataSource = computed(() => {
  return transactionWithdrawListStore.data
})

const handleChangePage = (page: number) => {

  transactionWithdrawListStore.changePage(page)
}

const handleChangePageSize = (size: number) => {

  transactionWithdrawListStore.changePageSize(size)
}

const handleUpdateFilter = (filter: any) => {

  transactionWithdrawListStore.setFilter(filter)
}

const handleSort = (field: string, direction: string) => {

  transactionWithdrawListStore.toggleSort(field, direction)
}

const requestFetchTransactionWithdrawList = _.debounce(async () => {
  try{
    const res = await transactionWithdrawListStore.fetchList()
  } catch (e) {

  }
}, 500)

watch(()=> transactionWithdrawListStore.uuid, (newVal, oldVal) => {
  requestFetchTransactionWithdrawList()
})

onMounted(() => {
  transactionWithdrawListStore.resetFilter()

  if (props.account?.id) {
    transactionWithdrawListStore.putFilter('account_id', props.account.id)
  }

  if (props.defautAction === 'deposit') {
    transactionWithdrawListStore.putFilter('type', 'deposit')
  } else if (props.defautAction === 'withdraw') {
    transactionWithdrawListStore.putFilter('type', 'withdrawal')
  }

})

const handleResetFilter = () => {

  transactionWithdrawListStore.resetFilter()
}

</script>

<template>
  <dashboard-layout currentRoute="transaction/withdraw" page-title="Yêu cầu rút tiền">
    <filter-list
      :filter="filter"
      @update:filter="handleUpdateFilter"
      v-if="!props.account"
      @reset:filter="handleResetFilter"
    />
    <data-table
      :buttons="[
        {
          label: 'Nạp tiền thủ công',
          icon: 'tabler:moneybag-plus',
          class: 'btn bg-primary bg-hover-primary text-white',
          action: () => { displayDepositPanel = true },
          perm: 'account.deposit',
        },
        {
          label: 'Trừ tiền thủ công',
          icon: 'tabler:moneybag-minus',
          class: 'btn btn-danger bg-hover-secondary',
          action: () => { displayWithdrawPanel = true },
          perm: 'account.withdraw',
        },
      ]"
          :row-action-buttons="[
        {
          action: (e: MouseEvent, item: any) => {
            displayWithdrawProcessPanel = true
            selectedWithdrawItem = item
          },
          css: 'btn btn-cs',
          label: 'Xử lí',
          icon: 'iconamoon:edit-duotone',
        }
      ]"
      :custom-action-cell="true"
      :loading="loading"
      :tableConfig="TableConfig"
      :page-size="pageSize"
      :page="page"
      :total-page="dataSource?.totalPage || 0"
      :total-records="dataSource?.totalRecords || 0"
      :data="dataSource?.list || []"
      primaryField="code"
      @page-changed="handleChangePage"
      @pagesize-changed="handleChangePageSize"
      @on-sort="handleSort"
    />
    <Modal :show="displayDepositPanel" title="Nạp tiền vào tài khoản" @on:close="()=>{displayDepositPanel = false}">
      <DepositPanel :account="props.account" @update:closeModal="() => {
        displayDepositPanel = false
        //fetch list
        requestFetchTransactionWithdrawList()
      }"/>
    </Modal>
    <Modal :show="displayWithdrawPanel" title="Rút tiền từ tài khoản" @on:close="()=>{displayWithdrawPanel = false}">
      <WithdrawPanel :account="props.account" @update:closeModal="() => {
        displayWithdrawPanel = false
        //fetch list
        requestFetchTransactionWithdrawList()
      }"/>
    </Modal>
    <Modal :show="displayWithdrawProcessPanel" title="Xử lí rút tiền" @on:close="()=>{displayWithdrawProcessPanel = false}">
      <WithdrawProcess :account="selectedWithdrawItem" @update:closeModal="() => {
          displayWithdrawProcessPanel = false
          //fetch list
          requestFetchTransactionWithdrawList()
        }" />
    </Modal>

  </dashboard-layout>
</template>

<style scoped>

</style>
